import { render, staticRenderFns } from "./settings-lists-categories.vue?vue&type=template&id=b061f984&"
import script from "./settings-lists-categories.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-categories.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports